export default __webpack_public_path__ + "img/b16d6d861a0fd82aaf5c5e5b534a8772.png";